export const SELECIONA_ABA = 'SELECIONA_ABA';

export const selecionaAba = (aba) => async dispatch => {
  dispatch({ type: SELECIONA_ABA, payload: { aba: aba } });
};
